import type { Note, NoteCategory } from "../types.ts";

const CATEGORY_SVG: Record<NoteCategory, string> = {
  room: `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>`,
  note: `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>`,
  damage: `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>`,
};

export class NotePanel {
  private el: HTMLElement;
  private listEl: HTMLElement;
  private onDelete?: (id: string) => void;
  private onClick?: (id: string) => void;

  constructor(pane: HTMLElement, onDelete: (id: string) => void, onClick?: (id: string) => void) {
    this.onDelete = onDelete;
    this.onClick = onClick;

    this.el = pane;
    this.el.innerHTML = `
      <div class="np-list"></div>
      <div class="np-empty">No notes yet.<br>Use the Notes tool to add annotations.</div>
    `;
    this.listEl = this.el.querySelector(".np-list")!;
  }

  render(notes: Note[]): void {
    this.listEl.innerHTML = "";
    const empty = this.el.querySelector(".np-empty") as HTMLElement;
    empty.style.display = notes.length ? "none" : "block";

    for (const n of notes) {
      const item = document.createElement("div");
      item.className = "np-item";
      item.dataset.id = n.id;

      item.innerHTML = `
        <span class="np-icon np-icon--${n.category}">${CATEGORY_SVG[n.category]}</span>
        <div class="np-info">
          <span class="np-cat">${_catLabel(n.category)}</span>
          <span class="np-text">${escHtml(n.text)}</span>
        </div>
        <button class="np-del" title="Delete" data-id="${n.id}">\u00d7</button>
      `;
      item.addEventListener("click", () => {
        this.onClick?.(n.id);
      });
      item.querySelector(".np-del")!.addEventListener("click", (e) => {
        e.stopPropagation();
        this.onDelete?.((e.currentTarget as HTMLElement).dataset.id!);
      });
      this.listEl.appendChild(item);
    }
  }

  dispose(): void {
    this.el.innerHTML = "";
  }
}

function _catLabel(cat: NoteCategory): string {
  return { room: "Room", note: "Note", damage: "Damage" }[cat];
}

function escHtml(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
